/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import { HttpHeaders } from '@angular/common/http';

const httpOptionsConfiguration = {
    headers: new HttpHeaders({
        'accept': 'application/json',
        'Content-Type': 'application/json'
    })
};
export default httpOptionsConfiguration;
